import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class SharedUserDataService {

  private dataUserSource = new BehaviorSubject<any>({});
  getDataUserSession$ = this.dataUserSource.asObservable();

  constructor() { }

  /**
   * [setData]
   * @param data 
   * @param origin 
   */
  setDataUserSession(data: any, origin: string) {
    const objSend = {
      data: data,
      origin: origin
    };

    // console.log('-SharedService-',objSend);

    this.dataUserSource.next(objSend)

  }

  destroy() {
    this.dataUserSource.complete(); // Evita futuras emisiones
  }

}
